export default "__VITE_ASSET__B_PWM90f__"